import React from "react";
import { Box, Typography } from "@mui/material";
import AICommentAnalyzer from "../AICommentAnalyzer";
import AIContentOptimizer from "../AIContentOptimizer";
import AIEngagementHub from "../AIEngagementHub";
import AutoAwesomeIcon from "@mui/icons-material/AutoAwesome";
import SmartToyIcon from "@mui/icons-material/SmartToy";
import ShieldIcon from "@mui/icons-material/Shield";

export default function AIToolsPage({ token, pageId }) {
  return (
    <Box sx={{ pb: 6 }}>
      {/* Header */}
      <div className="flex items-center gap-2 mb-2">
        <AutoAwesomeIcon className="text-primary-600 dark:text-primary-400" />
        <Typography variant="h6" className="text-2xl font-bold text-gray-900 dark:text-white">
          Creative Studio
        </Typography>
      </div>

      <div className="card-modern p-6 mt-6 border-2 border-primary-50 dark:border-primary-900/30">
        <Typography variant="h6" className="text-xl font-bold text-gray-900 dark:text-white mb-6 flex items-center gap-2">
          <ShieldIcon className="text-primary-500" />
          AI Brand Health & Reputation Hub
        </Typography>
        <AIEngagementHub token={token} pageId={pageId} />
      </div>

      <div className="card-modern p-6 mt-6">
        <Typography variant="h6" className="text-xl font-bold text-gray-900 dark:text-white mb-6 flex items-center gap-2">
          <SmartToyIcon className="text-purple-500" />
          AI Comment Drafting Pilot
        </Typography>
        <AICommentAnalyzer token={token} onGenerateResponse={() => {}} />
      </div>

      <div className="card-modern p-6 mt-6 opacity-80">
        <Typography variant="h6" className="text-xl font-bold text-gray-900 dark:text-white mb-4">
          AI Content Optimizer
        </Typography>
        <AIContentOptimizer />
      </div>
    </Box>
  );
}

